import { cnav, cache,host, cuser } from '@/store/store'
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [



  {
    path: '/thview',
    name: 'thview',
    component: () => import('../views/ThingUser.vue'),
    meta: { auth: false }
  },

/*
  {
    path: '/allthings',
    name: 'allthings',
    component: () => import('../views/AllThingsView.vue')
  }
  ,*/

  {
    path: '/cache',
    name: 'cache',
    component: () => import('../views/CacheView.vue')
  }
  ,


  {
    path: '/filedl',
    name: 'filedl',
    component: () => import('../views/FileDlg.vue')
  }
  ,

  {
    path: '/h',
    name: 'h',
    component: () => import('../views/HomeView.vue'),
    meta: { auth: false }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import("../views/Lojin.vue"),
    meta: { auth: false }
  },

  {
    path: "/welcome",
    name: "welcome",
    component: () => import("../components/welcome/TheWelcome.vue"),
    meta: { auth: false },
  },

  {
    path: "/",
    name: "wecome",
    component: () => import("../components/welcome/WeKome.vue"),
    meta: { auth: false },
  },

  {
    path: "/serial",
    name: "serial",
    component: () => import("../views/Serial.vue"),
    meta: { auth: false },
  },


  {
    path: "/examp",
    name: "examp",
    component: () => import("../views/bootstrap/GaugeExample.vue"),
    meta: { auth: false }
  },
  {
    path: "/simple",
    name: "simple",
    component: () => import("../views/socket/SimpChat.vue"),
    meta: { auth: true },
  },

  {
    path: "/datach",
    name: "datach",
    component: () => import("../views/socket/DataChat.vue"),
    meta: { auth: false },
  },
  {
    path: "/accessu",
    name: "accessu",
    component: () => import("../views/socket/RawChat.vue"),
    meta: { auth: true },
  },
  {
    path: "/stompchat",
    name: "stompchat",
    component: () => import("../views/socket/StompChatView.vue"),
    meta: { auth: true },
  }
  ,
  {
    path: "/socketv",
    name: "socketv",
    component: () => import("../views/socket/SocketView.vue"),
    meta: { auth: false },
  },
  {
    path: '/peson',
    name: 'peson',
    component: () => import('../views/HiveDatas.vue'),
    meta: { auth: true },
  },
  {
    path: '/ptnt',
    name: 'ptnt',
    component: () => import('../views/petrinet/PtnEditor.vue'),
    meta: { auth: true },
  },
  {
    path: '/orthoc',
    name: 'orthoc',
    component: () => import('../views/OrthoConnect.vue'),
    meta: { auth: false },
  },
  {
    path: '/demomime',
    name: 'DemoMime',
    component: () => import("../views/DemoMime.vue"),
    meta: { auth: false },
  },
  {
    path: "/socketv",
    name: "socketv",
    component: () => import("../views/socket/SocketView.vue"),
    meta: { auth: false },
  },
  {
    path: '/qrc',
    name: 'qrc',
    component: () => import('../views/QrCode.vue'),
    meta: { auth: false },
  },

  {
    path: '/demomime',
    name: 'DemoMime',
    component: () => import('../views/DemoMime.vue'),
    meta: { auth: false }
  },
  {
    path: '/sdata',
    name: 'sdata',
    component: () => import('../views/DataView.vue'),
    meta: { auth: false }
  },
  {
    path: "/populated",
    name: "populated",
    component: () => import("../views/PopulateView.vue"),
    meta: { auth: false },
  },
  {
    path: "/mycommands",
    name: "mycommands",
    component: () => import("../views/MyCommands.vue"),
    meta: { auth: false },
  },
  {
    path: '/commerce',
    name: 'commerce',
    component: () => import('../views/CommercePage.vue'),
    meta: { auth: false },
  },
  {
    path: '/results',
    name: 'results',
    component: () => import('../views/ResultView.vue'),
    meta: { auth: false }
  },
  {
    path: '/employees',
    name: 'employees',
    component: () => import('../views/EmployeeView.vue'),
    meta: { auth: false }
  },

  /*
  {
    path: '/agents',
    name: 'agents',
    component: () => import('../views/AgentView.vue'),
    meta: { auth: false }
  },
*/
 
  {
    path: '/devicedata',
    name: 'devicedata',
    component: () => import('../views/DeviceDataView.vue'),
    meta: { auth: false }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/bootstrap',
    name: 'bootstrap',
    component: () => import('../views/bootstrap/BootstrapForm.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/bootstrapf',
    name: 'bootstrapf',
    component: () => import('../views/bootstrap/BootstrapDashboard.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/bootstrapt',
    name: 'bootstrapt',
    component: () => import('../views/bootstrap/BootstrapTable.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/chart',
    name: 'chart',
    component: () => import('../views/ChartView.vue'),
    meta: { auth: false }
  }
 
  ,
  {
    path: '/chartws',
    name: 'chartws',
    component: () => import('../components/demo/WsDemo.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/trendline',
    name: 'trendline',
    component: () => import('../views/TrendlineView.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/data',
    name: 'data',
    component: () => import('../views/SimpleDataView.vue'),
    meta: { auth: false }
  }
   ,
  {
    path: '/eval',
    name: 'eval',
    component: () => import('../views/EvalDataView.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/hivedata',
    name: 'hivedata',
    component: () => import('../views/HiveDataView.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/thing2',
    name: 'thing2',
    component: () => import('../views/Thing2View.vue'),
    meta: { auth: false }
  }

,
  {
    path: '/thing22',
    name: 'thing22',
    component: () => import('../views/Thing22View.vue'),
    meta: { auth: false }
  }

  ,
  {
    path: '/thing3',
    name: 'thing3',
    component: () => import('../views/Thing3View.vue')
  }
  ,
  {
    path: '/dscalec',
    name: 'dscalec',
    component: () => import('../views/DatascaleCorrView.vue')
  }
  ,
  {
    path: '/matrix',
    name: 'matrix',
    component: () => import('../views/MatrixView.vue')
  }
  ,
  {
    path: '/sites',
    name: 'sites',
    component: () => import('../views/SiteView.vue')
  }
  ,
  {
    path: '/chives',
    name: 'chives',
    component: () => import('../views/ChooseThing.vue')
  }
  ,
  {
    path: '/things',
    name: 'things',
    component: () => import('../views/Thing4View.vue')
  }
  ,
  {
    path: '/interpolation',
    name: 'interpolation',
    component: () => import('../views/interpolation/Interpolation1View.vue')
  }
  ,
  {
    path: '/interp',
    name: 'interp',
    component: () => import('../views/interpolation/Interpolation2View.vue')
  }
  ,
  {
    path: '/interpol',
    name: 'interpol',
    component: () => import('../views/interpolation/Interpolation3View.vue')
  }
  ,
  {
    path: '/interpol4',
    name: 'interpol4',
    component: () => import('../views/interpolation/Interpolation4View.vue')
  }
  ,
  {
    path: '/interpol5',
    name: 'interpol5',
    component: () => import('../views/interpolation/Interpolation5View.vue')
  }
  ,
  {
    path: '/interpol6',
    name: 'interpol6',
    component: () => import('../views/interpolation/Interpolation6View.vue')
  }
  ,
  {
    path: '/correc3',
    name: 'correc3',
    component: () => import('../views/correction/CorrectionView3.vue')
  }
  ,
  {
    path: '/hdcorrec',
    name: 'hdcorrec',
    component: () => import('../views/correction/HiveDataCorrectionView.vue')
  }
  ,
  {
    path: '/line',
    name: 'line',
    component: () => import('../components/demo/LineView.vue')
  }
  ,
  {
    path: '/scatter',
    name: 'scatter',
    component: () => import('../components/demo/ScatterView.vue'),
    meta: { auth: false }
  }
  ,
  {
    path: '/ortho',
    name: 'ortho',
    component: () => import('../views/OrthoConnect.vue')
  }
  /*
  ,
  {
    path: '/draw',
    name: 'draw',
    component: () => import('../components/demo/DrawView.vue')
  }*/
  ,
  {
    path: '/draw3',
    name: 'draw3',
    component: () => import('../views/DrawApp3.vue')
  },
  //yarn add file:../tscanvas  && declare module "tscanvas";
  {
    path: '/calc',
    name: 'calc',
    component: () => import('../components/demo/CalcComponent.vue')
  },
  {
    path: '/ptnt',
    name: 'ptnt',
    component: () => import('../views/petrinet/PtnEditor.vue'),
    meta: { auth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/ErrorPage.vue'),
  },
    
  {
    path: '/jpq',
    name: 'jpq',
    component: () => import('../views/Jpq.vue')
  }
]



const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

/*
[]
  component: () => import('../views/petrinet/PtnEditor.vue'),

router.beforeEach((to, from, next) => {
  const IsItABackButton = window.popStateDetected
  window.popStateDetected = false
  if (IsItABackButton && from.meta.someLogica) {
    next(false) 
    return ''
  }
  next()
})
*/

function isAuthenticated(): boolean {
  return cuser.login !== ''
}

function isFreeAccess(to: RouteRecordRaw): boolean {
  let r = true //if no meta allow
  const tm = to && to.meta
  if (tm && tm.auth) {
    r = !tm.auth //auth == needs to be logged in
  }
  return r
}

function contextThingsDefined(): boolean {
  return cache.contextThings.length > 0
}

router.beforeEach((to: any, from: any) => {
  console.log('route-before from ' + from.name + ' to ' + to.name)
  // const IsItABackButton = window.popStateDetected 
  if (from)
    cnav.from = from.name
  if (to)
    cnav.to = to.name
  if (to.name !== 'profile') {
    cnav.cpath = to.path
    console.log('cnav=' + cnav.cpath)
  }
  if (to.query) {
    try {
      console.log('TO QUERY ' + JSON.stringify(to.query))
      const q = { lout: 'false' }
      q.lout = to.query.lout
      if (q.lout === 'true') {
        console.log('LOGOUT')
        cnav.logout = true
      } else {
        console.log('(1)LOGIN')
      }
    } catch (error) {
      console.log('(ERROR)LOGIN')
      //console.error(error);
    }
  } else {
    console.log('(2)LOGIN')
  }
  if (!isAuthenticated() && !isFreeAccess(to)) {
    // alert('please login !');//see https://fontawesomeicons.com/fa/vue-js-disappear-alert-automatically-after-5-seconds
    return { name: 'profile' }
  } else if (!contextThingsDefined() && to.name === 'thing2') {
    alert('choose things !')
    return { name: 'chives' }
  }

  return true
})


router.afterEach((to: any, from: any) => {
  console.log('route-after to ' + to.name + ' cnav.cpath=' + cnav.cpath)
  if (to.name == 'profile' && cnav.cpath !== '/') {
    console.log('redirected to login')
    if (cnav.logout) {
      console.log('was logging out')
      cnav.cpath = '/' //invalidate route to welcome
    }
    //if (to.)
    //cnav.cpath='/';
  }
  return true
})






export default router
